
export interface User {
  id: string;
  username: string;
  email: string;
  password?: string;
  avatar?: string;
}

export type DesignType = 'original' | 'minimalist' | 'glassmorphism' | 'neo_brutalism' | 'flat' | 'experimental_original';

export interface UserSettings {
  levelTitles?: string[];
  design?: DesignType;
  designColors?: {
    primary: string;
    secondary: string;
  };
}

export interface Todo {
  id: string;
  text: string;
  points: number;
  completed: boolean;
  createdAt: number;
  completedAt?: number;
  recurrence?: 'daily' | 'weekly' | 'monthly';
  accumulatedPoints?: number;
  snoozedUntil?: number;
  timeSpent?: number;
  activeSessionStart?: number;
  scheduledDate?: number;
  difficulty?: 'easy' | 'medium' | 'hard';
  timeConsumption?: 'short' | 'medium' | 'long';
  contributesTo?: string[];
  targetCount?: number;
  currentCount?: number;
}

export enum BucketTheme {
  Blue = 'blue',
  Purple = 'purple',
  Green = 'green',
  Orange = 'orange',
  Pink = 'pink',
  Red = 'red',
  Teal = 'teal',
  Yellow = 'yellow',
  Indigo = 'indigo',
  Cyan = 'cyan',
  Lime = 'lime',
  Rose = 'rose',
}

export enum BucketType {
  Standard = 'standard',
  FokusSprint = 'fokus_sprint'
}

export interface BucketGoal {
  title?: string;
  targetPoints: number;
  deadline: number;
}

export interface RecurringGoal {
  targetPoints: number;
  interval: 'month';
}

export interface Milestone {
  id: string;
  title: string;
  targetPoints: number;
  reachedAt: number;
}

export interface Bucket {
  id: string;
  name: string;
  description?: string;
  theme: BucketTheme;
  type: BucketType;
  headerImage?: string;
  todos: Todo[];
  goal?: BucketGoal;
  recurringGoal?: RecurringGoal;
  milestones?: Milestone[]; 
  startDate?: number;
  endDate?: number;
  createdAt: number;
}

export interface Idea {
  id: string;
  text: string;
  createdAt: number;
}

export type CreateBucketData = Pick<Bucket, 'name' | 'theme' | 'description'>;
